import React from 'react';
import { Dropdown, DropdownMenu, DropdownToggle, DropdownItem } from 'reactstrap';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import { UserContext, API_HOST, EXAMS_UI_HOST } from '../consts';
import Logo from '../assets/images/logos/Logos';
import UserImg from '../assets/images/dev/faceimg.jpg';
import { ThemeContext } from '../contexts/ThemeContext';
import { Grid } from '@material-ui/core';
import axios from 'axios';

export default class NavHeader extends React.Component {
  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.toggleOptions = this.toggleOptions.bind(this);
    this.toggleConfig = this.toggleConfig.bind(this);
    this.state = {
      dropdownUser: false,
      dropdownOptions: false,
      toggleConfig: false,
    };
  }

  mapMetadata(metadata) {
    const mapped = {};
    metadata.forEach((m) => {
      mapped[`${m.model}.${m.name}`] = m.requireness;
    });
    return mapped;
  }

  shouldDisplay(field) {
    const { metadata } = this.state;
    return get(metadata, field) > 0;
  }
  fetchMetadata() {
    this.setState({ fetchingMetadata: true });
    return axios
      .get(`${API_HOST}/params/param?model=nav`)
      .then((response) => {
        this.setState({
          metadata: this.mapMetadata(response.data),
          fetchingMetadata: false
        });
      });
  }

  componentDidMount() {
    this.fetchMetadata();
  }

  toggle() {
    this.setState({
      dropdownUser: !this.state.dropdownUser
    });
  }
  toggleOptions() {
    this.setState({
      dropdownOptions: !this.state.dropdownOptions
    });
  }

  toggleConfig() {
    this.setState({
      toggleConfig: !this.state.toggleConfig
    });
  }

  toggleHelp = () => {
    this.setState({
      toggleHelp: !this.state.toggleHelp
    });
  };

  logout() {
    localStorage.removeItem('token');
    window.open('/login', '_self');
  };

  changeProfile() {
    localStorage.removeItem('payload_permissions');
    window.location.href = '/escolher-instituicao';
  };

  setLoggedGroup(group) {
    return axios
      .post(`${API_HOST}/login/user/update_logged_group`,{'perfil':group})
      .then((response) => {
        window.location.reload()
      });
  };

  async loginAsStudent(userId) {
    const response = await axios.post(`${API_HOST}/external-auth/bridge_token?user_id=${userId}`)

    window.location.replace(`${EXAMS_UI_HOST}/educat-bridge/${response.data.token}`)
  };

  render() {
    const token = localStorage.getItem('token');
    const host = window.location.host;
    const href = window.location.href;
    return (
      <UserContext.Consumer>
        {({ user, permissions, groups,logged_group }) => (
        <ThemeContext.Consumer>
          {(theme) => (
            <Grid container alignItems="center" direction="row">
              <Grid item container xs={6}>
                <figure>
                      <Link to="/" style={{ marginLeft: '5.5rem' }}>
                        <img
                          className={
                            Logo.client ? 'logo-client' : 'logo-main'
                          }
                          src={theme.logoImg || Logo.client || Logo.main}
                          alt={Logo.clientText || Logo.mainText}
                          height="30"
                        />
                      </Link>
                </figure>
              </Grid>

              <Grid item container justifyContent="center" xs={6}>
                {/* <NavItem className="menu-config">
                  <Dropdown
                    isOpen={this.state.toggleConfig}
                    toggle={this.toggleConfig}
                  >
                    <DropdownToggle className="dropdown-nav">
                      <i
                        className="fas fa-cog"
                        style={{ fontSize: '20px', verticalAlign: 'middle' }}
                      />
                    </DropdownToggle>
                    <DropdownMenu position="left">
                      {get(permissions, '__all__') && (
                        <Fragment>
                          <span className="dropdown-item divider-menu">
                            Administração
                          </span>
                          <a
                            href={`${API_HOST}/login/admin-redirect/${token}`}
                            className="dropdown-item children-menu"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Painel <i className="fa fa-external-link" />
                          </a>
                        </Fragment>
                      )}
                      <span className="dropdown-item divider-menu">
                        Usuários
                      </span>
                      <Link
                        onClick={this.toggleConfig}
                        className="dropdown-item children-menu"
                        to="/usuarios"
                      >
                        Lista
                      </Link>
                      <span className="dropdown-item divider-menu">
                        Grupos
                      </span>
                      <button
                        type="button"
                        className="disabled dropdown-item children-menu"
                      >
                        Lista
                      </button>
                    </DropdownMenu>
                  </Dropdown>
                </NavItem> */}

                {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "1rem" }}>
                  <Dropdown
                    isOpen={this.state.dropdownUser}
                    toggle={this.toggle}
                    style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "0" }}
                  >
                    <DropdownToggle
                      className="dropdown-nav"
                      style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "0", padding: "0" }}
                    >
                      <i
                        className="far fa-bell"
                        style={{ fontSize: '20px', verticalAlign: 'middle' }}
                      />
                    </DropdownToggle>
                    <DropdownMenu right>
                      <DropdownItem className="dropdown-item divider-menu ">
                        0 notificações
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                </div> */}

                {(
                  href.includes('personal') || href.includes('report-plan')
                ) ? <></> : (
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "center", marginRight: "1rem" }}>
                  <Dropdown
                    isOpen={this.state.toggleHelp}
                    toggle={this.toggleHelp}
                    style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "0" }}
                  >
                    <DropdownToggle
                      className="dropdown-nav"
                      style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "0", padding: "0" }}
                    >
                      <i
                        className="fas fa-question-circle"
                        style={{ fontSize: '20px', verticalAlign: 'middle' }}
                      />
                    </DropdownToggle>
                    <DropdownMenu position="left">
                      <span className="dropdown-item divider-menu">
                        AJUDA
                      </span>
                      {/* <a
                        onClick={this.toggleHelp}
                        className="dropdown-item children-menu"
                        href="https://educat.freshdesk.com/support/login"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Abrir chamado <i className="fa fa-external-link" />
                      </a> */}

                      <a
                        onClick={this.toggleHelp}
                        className="dropdown-item children-menu"
                        href='https://educat.com.br/faq/adaptativo'
                        target="_blank"
                        rel="noopener noreferrer"
                      // to='/faq'
                      // className="dropdown-item children-menu"
                      // target="_blank"
                      // rel="noopener noreferrer"
                      >
                        FAQ <i className="fa fa-commenting-o" aria-hidden="true" />
                      </a>

                    </DropdownMenu>
                  </Dropdown>
                </div>
                )}

                <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-start", }}>
                  <div style={{ display: 'flex', alignItems: "center", justifyContent: "center" }}>
                    {/* <Link to="/perfil"> */}
                    <figure style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "0" }}>
                      <img src={UserImg} className="img-user" alt="user" style={{ margin: "0" }} />
                    </figure>
                    {/* </Link> */}
                    <Dropdown
                      isOpen={this.state.dropdownOptions}
                      toggle={this.toggleOptions}
                      style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "0" }}
                    >
                      <DropdownToggle
                        className="dropdown-nav"
                        style={{ display: "flex", alignItems: "center", justifyContent: "center", margin: "0", padding: "0" }}
                      >
                        <span className="user-name">
                          {get(user, 'last_name')}
                        </span>
                      </DropdownToggle>
                      <DropdownMenu position="right">
                        {/* <span className="dropdown-item children-informations">
                          Nome: {get(user, 'last_name')}
                        </span>
                        <span className="dropdown-item children-informations">
                          Instituição: {get(groups, 'instituicao.label')}
                        </span>
                        <hr className="hr-menu" />
                        <Link
                          onClick={this.toggleOptions}
                          className="dropdown-item children-menu"
                          to="/perfil"
                        >
                          Alterar Senha
                        </Link>
                        <Link
                          onClick={this.changeProfile}
                          className="dropdown-item children-menu"
                          to="/escolher-instituicao"
                        >
                          Alterar Perfil
                        </Link>
                        <hr className="hr-menu" /> */}
                        <span className="dropdown-item children-informations-strong">
                          Meu Perfil:
                        </span>
                        {this.shouldDisplay('nav.plurallActions') && (
                          <>
                            <Link
                              onClick={() => {
                                window.open(
                                  'https://conta.plurall.net/perfil/dados-pessoais',
                                  '_self'
                                );
                              }}
                              className="dropdown-item children-menu"
                              to="/"
                              >
                              Dados pessoais e acesso
                            </Link>
                            <Link
                            onClick={() => {
                              window.open(
                                'https://conta.plurall.net/perfil/dados-escolares',
                                '_self'
                              );
                            }}
                            className="dropdown-item children-menu"
                            to="/"
                            >
                              Dados escolares
                            </Link>
                            {/* <Link
                            onClick={() => {
                              window.open(
                                'https://conta.plurall.net/perfil/codigo-acesso',
                                '_self'
                              );
                            }}
                            className="dropdown-item children-menu"
                            to="/"
                            >
                            Código de acesso
                          </Link> */}
                            <Link
                            onClick={() => {
                              window.open(
                                'https://conta.plurall.net/perfil/privacidade',
                                '_self'
                              );
                            }}
                            className="dropdown-item children-menu"
                            to="/"
                            >
                              Privacidade
                            </Link>
                          </>
                        )}
                        <span className="dropdown-item children-informations">
                          Permissão atual: {get(user, 'logged_group') && get(user, 'logged_group')[0]}
                        </span>

                        {
                        get(user, 'groups') ? get(user, 'groups').map((group) =>
                          <span
                            className="dropdown-item children-informations"
                            style={{
                              padding: '4px 24px'
                            }}
                          >
                            <button
                              style={{
                                fontFamily: "Inter",
                                fontSize: "12px",
                                fontWeight: 400,

                                backgroundColor: theme.action,
                                borderRadius: "4px",
                                padding: "4px 8px",
                                border: "none",
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}
                            >
                              <div style={{display: 'flex', alignItems: "center"}}>
                                {get(user, 'logged_group')[0] === group && (
                                  <div
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      borderRadius: "50%",
                                      backgroundColor: theme.primary,
                                      marginRight: "8px"
                                    }}
                                  />
                                )}
                                {group.charAt(0) + group.slice(1).toLowerCase()}
                              </div>

                              {get(user, 'logged_group')[0] !== group && (
                                <button
                                  style={{
                                    backgroundColor: theme.primary,
                                    borderRadius: "4px",
                                    padding: "4px 8px",
                                    border: "none",

                                    fontFamily: "Inter",
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    lineHeight: "14.52px",
                                    color: "#ffffff"
                                  }}
                                  onClick={()=>this.setLoggedGroup(group)}
                                >
                                  Acessar
                                </button>
                              )}

                            </button>
                          </span>

                        ):
                        <></>
                        }

                        <span className="dropdown-item children-informations">
                          Dependentes:
                        </span>
                        {

                        get(user, 'dependents') ? get(user, 'dependents').map((dependents) =>
                          <span
                            className="dropdown-item children-informations"
                            style={{
                              padding: '4px 24px'
                            }}
                          >


                            <button
                              style={{
                                fontFamily: "Inter",
                                fontSize: "12px",
                                fontWeight: 400,

                                backgroundColor: theme.action,
                                borderRadius: "4px",
                                padding: "4px 8px",
                                border: "none",
                                width: "100%",
                                display: "flex",
                                justifyContent: "space-between",
                                alignItems: "center"
                              }}
                            >
                              <div style={{display: 'flex', alignItems: "center"}}>
                                {dependents[1] !== undefined && (
                                  <div
                                    style={{
                                      width: "10px",
                                      height: "10px",
                                      borderRadius: "50%",
                                      backgroundColor: theme.primary,
                                      marginRight: "8px"
                                    }}
                                  />
                                )}
                                {dependents[0]}
                              </div>

                              {dependents[1] !== undefined && (
                                <button
                                  style={{
                                    backgroundColor: theme.primary,
                                    borderRadius: "4px",
                                    padding: "4px 8px",
                                    border: "none",

                                    fontFamily: "Inter",
                                    fontSize: "12px",
                                    fontWeight: 400,
                                    lineHeight: "14.52px",
                                    color: "#ffffff"
                                  }}
                                  onClick={()=>this.loginAsStudent(dependents[1])}
                                >
                                  Acessar
                                </button>
                              )}

                            </button>
                          </span>

                        ):
                        <></>
                        }
                        <hr className="hr-menu" />
                        <Link
                          onClick={this.logout}
                          className="dropdown-item children-menu"
                          to="/configuracoes/grupos"
                        >
                          Sair
                        </Link>
                      </DropdownMenu>
                    </Dropdown>
                  </div>
                </div>
              </Grid>
            </Grid >
            )}
          </ThemeContext.Consumer>
        )}
      </UserContext.Consumer >
    );
  }
}
